export const formatDate = date => {
  if (date && !isNaN(date?.getTime())) {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
  }
}

export const getInitialDates = rangeValue => {
  const startDate = new Date(rangeValue?.startDate)
  const endDate = new Date(rangeValue?.endDate)

  return {
    startDate: isNaN(startDate.getTime()) ? null : startDate,
    endDate: isNaN(endDate.getTime()) ? null : endDate,
  }
}

export const getSelectBackgroundColor = (backgroundColor, theme) => {
  if (backgroundColor) return backgroundColor

  return theme.colors.background.secondary
}

export const parseInputDate = value => {
  const [day, month, year] = value.split('/')

  return new Date(year, month - 1, day)
}

const isSameInputDate = (value, date) => {
  const [day, month] = value.split('/').map(Number)

  return date.getDate() === day && date.getMonth() + 1 === month
}

export const isCustomDateRangeValid = (startDate, endDate, minDate, maxDate) => {
  const regex = /^\d{1,2}\/\d{1,2}\/\d{4}$/

  if (!regex.test(startDate) || !regex.test(endDate)) return false
  if (!minDate && !maxDate) return true

  const start = parseInputDate(startDate)
  const end = parseInputDate(endDate)

  if (!isSameInputDate(startDate, start) || !isSameInputDate(endDate, end)) return false

  return start <= end && (!minDate || start >= minDate) && (!maxDate || end <= maxDate)
}
